import { module } from 'modujs';
import Env from '../base/env';

export default class extends module {
  constructor(m) {
    super(m);
    this.events = {
      click: {
        trigger: 'open',
        close: 'close',
      },
    };
  }

  init() {
    this.DOM = {
      view: this.el,
    };
  }

  close() {
    this.DOM.view.classList.remove('is-active');
    Env.$html.classList.remove('popin-opened');
    Env.$html.classList.remove('panel-opened');
  }

  open() {
    this.DOM.view.classList.add('is-active');
    Env.$html.classList.add('popin-opened');
    Env.$html.classList.add('panel-opened');
  }
}
